export default __webpack_public_path__ + "static/media/pref-positivo.88ed1807.svg";